import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { CheckCircle2, XCircle } from 'lucide-react';

// /nutricao/sair/:token — link do rodapé dos e-mails de nutrição do quiz das landing pages.
const NurtureUnsubscribe: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const { t } = useTranslation();
  const [state, setState] = useState<'loading' | 'done' | 'error'>('loading');

  useEffect(() => {
    let cancelled = false;
    axios.post(`/landing-pages/nurture/unsubscribe/${token}`)
      .then(() => { if (!cancelled) setState('done'); })
      .catch(() => { if (!cancelled) setState('error'); });
    return () => { cancelled = true; };
  }, [token]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4 py-16">
      <div className="card max-w-md w-full text-center">
        {state === 'loading' ? (
          <p className="text-gray-600">{t('landingQuiz.unsubscribe.loading')}</p>
        ) : (
          <>
            {state === 'done'
              ? <CheckCircle2 className="w-12 h-12 text-green-600 mx-auto mb-4" />
              : <XCircle className="w-12 h-12 text-red-500 mx-auto mb-4" />}
            <h1 className="text-2xl font-bold text-gray-900 mb-2">
              {state === 'done' ? t('landingQuiz.unsubscribe.title') : t('landingQuiz.unsubscribe.errorTitle')}
            </h1>
            <p className="text-gray-600 mb-6">
              {state === 'done' ? t('landingQuiz.unsubscribe.message') : t('landingQuiz.unsubscribe.errorMessage')}
            </p>
            <Link to="/" className="btn-primary">{t('landingQuiz.unsubscribe.backHome')}</Link>
          </>
        )}
      </div>
    </div>
  );
};

export default NurtureUnsubscribe;
